import { render, staticRenderFns } from "./ModalGantt.vue?vue&type=template&id=40bfb15b&scoped=true&"
import script from "./ModalGantt.vue?vue&type=script&lang=js&"
export * from "./ModalGantt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bfb15b",
  null
  
)

export default component.exports